module.exports = __webpack_public_path__ + "img/text.c08ecbc5.png";